import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=228ac58c&scoped=true&lang=pug&"
import script from "./loading.vue?vue&type=script&lang=ts&"
export * from "./loading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ac58c",
  null
  
)

export default component.exports